export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID || "1576815446644509";
export const META_GRAPH_VERSION = "v22.0";
export const META_ALLOWED_EVENTS = [
    "PageView",
    "ViewContent",
    "Lead",
    "Contact",
    "Schedule",
    "CompleteRegistration",
] as const;

export type MetaStandardEvent = (typeof META_ALLOWED_EVENTS)[number];

export function isMetaStandardEvent(value: string): value is MetaStandardEvent {
    return (META_ALLOWED_EVENTS as readonly string[]).includes(value);
}

export const META_PAGE_CONTENT: Record<string, { event?: MetaStandardEvent; contentName: string; contentCategory: string }> = {
    "/lpmoov1": { event: "ViewContent", contentName: "LP Moov 1", contentCategory: "landing" },
    "/lpmoov2": { event: "ViewContent", contentName: "LP Moov 2", contentCategory: "landing" },
    "/lpmoov1/obrigado": {
        event: "CompleteRegistration",
        contentName: "LP Moov 1 — Cadastro CRM",
        contentCategory: "conversion",
    },
    "/lpmoov2/obrigado": {
        event: "Contact",
        contentName: "LP Moov 2 — WhatsApp",
        contentCategory: "conversion",
    },
};

export function getMetaPageContent(pathname: string) {
    const normalized = pathname.replace(/\/$/, "") || "/";
    return META_PAGE_CONTENT[normalized];
}
